export default "__VITE_ASSET__waHIIINT__"